import Text from "./Text.mjs";
import TextWrapper from "./TextWrapper.mjs";
export * from "./Text.mjs";
export * from "./TextContext.mjs";
export * from "./TextWrapper.mjs";
var lib_default = Text;
export {
  TextWrapper,
  lib_default as default
};
